import { dom, library } from '@fortawesome/fontawesome-svg-core';
import { all } from '@awesome.me/kit-62a5128e0a/icons'

library.add(...all)

// convert i tags to SVG
dom.watch({
    autoReplaceSvgRoot: document,
    observeMutationsRoot: document.body
})
